$(function () {
    // Simple addition to disable file input until type has been selected.
    if ($(".doc_new form input[name='form-form_id']").val() == 96) {
        $("[name='person_document-file']").prop("disabled", true);
        $("[name='person_document-document_type_id']").on("change", function () {
            const disabled = $("[name='person_document-document_type_id'] :selected").val() < 0;
            $("[name='person_document-file']").prop("disabled", disabled);
        });
    }

    $('body').on(
        'change',
        'input[name="person_document-file"]',
        function () {
            $(".errorMessage").remove();
            const personId = $("input[name='person_document-person_id']").val();
            const documentType = $("[name='person_document-document_type_id'] :selected").val();
            const documentName = $("[name='person_document-document_type_id'] :selected").text();

            const uploadProgressBarID = $(this).attr('id') + "Progress";
            const bar = {
                percent: 0,
                draw: function () {
                    const maxwidth = 250;
                    const width = Math.ceil(this.percent * maxwidth);
                    if (width > 40) {
                        $("#" + uploadProgressBarID).css('width', width + "px");
                    }

                    $("#" + uploadProgressBarID).attr('aria-valuenow', Math.ceil((this.percent * 100)) + 15);
                    $("#" + uploadProgressBarID).html(Math.ceil((this.percent * 100)) + ' %');
                }
            };

            const $this = $(this);
            const up = document.getElementById($(this).attr('id')).files;

            $("#" + $this.attr('id') + "InfoMessage").remove();
            if ($("#" + $this.attr('id') + "Progress").length) {
                $("#" + $this.attr('id') + "Progress").remove();
                $(".progressBar").remove();
            }
            $("#uploadInfoMessage").css('display', 'none');

            if (up.length == 0) {
                $("#uploadInfoMessage").css('display', 'block');
            } else {
                let originalName = 'NONAME';
                if (up[0].name !== '') {
                    originalName = up[0].name;
                }

                const extension = $(this).val().replace(/^.*\./, '');
                if (!["PDF", "DOC", "DOCX"].includes(extension.toUpperCase())) {
                    $this.parent().append('<div class="alert alert-danger fade in alert-dismissible col-xs-12 col-sm-12 col-md-12 col-lg-9 errorMessage" id="' + $this.attr('id') + 'InfoMessage"><a href="#" class="close" data-dismiss="alert" aria-label="close" title="close">×</a><strong>FILE ERROR: </strong>The file format is not supported.<br>Please upload a <b>.PDF, .DOC, .DOCX</b></div>');
                    $this.val('');
                } else {
                    const maxFileSizeInput = $('input[name="MAX_FILE_SIZE"]');
                    const maxFileSize = maxFileSizeInput.val();
                    if (maxFileSize > 0 && maxFileSize < up[0].size) {
                        const maxFileSizeHuman = maxFileSizeInput.parent().data('max-file');
                        $this.val(''); // clear file if size is bigger than allowed to prevent form submit
                        $this.parent().append('<div class="alert alert-danger fade in alert-dismissible errorMessage" id="' + $this.attr('id') + 'InfoMessage"><a href="#" class="close" data-dismiss="alert" aria-label="close" title="close">×</a><strong>UPLOAD ERROR: </strong>Cannot upload files larger than <b>' + maxFileSizeHuman + '</b>.<br>Please try uploading a smaller file.<br></div>');
                    } else {
                        const data = new FormData();
                        data.append("uploadFile", up[0]);
                        if (typeof personId !== 'undefined') {
                            data.append("personId", personId);
                            const itemId = getUrlParameter("id");
                            data.append("applicationId", itemId);
                        }
                        if (typeof documentType !== 'undefined') {
                            data.append("documentType", documentType);
                        }

                        $(this).parent().append('<div class="progressBar"><div class="uploadProgressBar progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="15" aria-valuemin="0" aria-valuemax="115" id="' + $(this).attr('id') + 'Progress" style="display:none; max-width: 250px; min-width: 40px; width: 40px; font-weight:bold; margin-bottom: 15px; text-transform: uppercase;letter-spacing: 1px;">0 %</div><div class="clearfix"></div></div></div>');

                        $(this).prev().fadeToggle('slow');
                        const originalText = $(this).prev().html();
                        $(this).fadeToggle('slow', function () {
                            $(this).prev().html('Uploading your file&hellip;');
                            $(this).prev().fadeToggle('slow');
                            $("#" + $(this).attr('id') + "Progress").fadeToggle('slow');
                        });

                        const xhr = new XMLHttpRequest();
                        xhr.open("POST", "/services/file/form_file_upload", true);
                        xhr.onload = function () {
                            const res = JSON.parse(this.response);
                            if (res.status) {
                                $('.wait-for-upload-message').remove();
                                $('.cv_upload_area').removeClass('has-error');
                                $("#" + $this.attr('id') + "Progress").delay(700).fadeToggle('fast', function () {
                                    $this.prev().fadeToggle('slow', function () {
                                        if (res.status !== "SUCCESS") {
                                            // Clear file if file upload fails/returns an error.
                                            $this.val('');
                                            $(this).prev().html('Please select and upload your CV');
                                            $(this).prev().fadeToggle('slow');
                                            $this.fadeToggle('slow');
                                            $this.closest('.view.form_page').append(`
                                                <div class="alert alert-danger fade in alert-dismissible col-xs-12 col-sm-12 col-md-12 col-lg-9 errorMessage" id="${$this.attr('id')}InfoMessage" style="display:none;">
                                                    <a href="#" class="close" data-dismiss="alert" aria-label="close" title="close">×</a>
                                                    <strong>UPLOAD ERROR:</strong>${res.info}
                                                </div>
                                            `);
                                        } else {
                                            if (res.info !== "UPLOAD FULLY COMPLETED") {
                                                if (
                                                    !$('input[name="person_document-file_id"]').length &&
                                                    res.file_id == parseInt(res.file_id, 10)
                                                ) {
                                                    $this.closest("form").prepend('<input type="hidden" name="person_document-file_id" value="' + res.file_id + '">');
                                                }
                                            } else if (typeof $this.closest("form").find('input[name="actions"]').attr('value') !== 'undefined') {
                                                const actionsInput = $this.closest("form").find('input[name="actions"]');
                                                let formActions = actionsInput.attr('value') ?? "applications/register_and_apply";
                                                if (formActions) {
                                                    formActions = formActions.split(',').filter(a => a !== "account/upload_document").join(',');
                                                }
                                                actionsInput.attr('value', formActions);
                                            }
                                            $this.prev().html(originalText);
                                            $this.prev().fadeIn('slow');
                                            $this.fadeIn('slow');
                                            $("#uploadInfoMessage").show();
                                            $this.parents('.view.form_page_section_field').append(`
                                                <div class="alert alert-info alert-dismissible errorMessage" id="${$this.attr('id')}InfoMessage" style="display:none;line-height: 30px;word-break: break-word;width:100%;float:left;clear:both;">
                                                    <div class="fa fa-check-circle" style="font-size: 30px; float: left; padding-right: 8px;"></div>
                                                    <div>Your file <strong>${originalName}</strong> has been successfully uploaded to us.</div>
                                                </div>`
                                            );
                                        }

                                        if (typeof itemId !== 'undefined' && res.status !== 'ERROR') {
                                            const span = '<a href="/administrator/preview?file=' + res.file_id + '" target="_blank"><span style="font-size:24px;cursor:pointer;padding-right:3px;width:85%;text-align:center;" ' +
                                                'class="fa fa-file-text-o docPrevButton"></span></a>';

                                            const tableHead = "<thead><tr><th class='even_row'>Type</th>" +
                                                "<th class='even_row'>Filename</th>" +
                                                "<th class='even_row'>Uploaded By</th>" +
                                                "<th class='even_row'>Last updated</th>" +
                                                "<th class='even_row'>View</th>" +
                                                "<th class='even_row'>Download</th>" +
                                                "<th class='even_row'>Delete</th>" +
                                                "</tr></thead>";
                                            const tableRow = "<tr></tr><td class='even_row'>" + documentName + "</td>" +
                                                "<td class='even_row'>" + res.file_name + "</td>" +
                                                "<td class='even_row'>" + res.user_name + "</td>" +
                                                "<td class='even_row'>" + res.date_modified + "</td>" +
                                                "<td class='even_row'>" + span + "</td>" +
                                                "<td class='even_row'><a href='/services/download?file_id=" + res.file_id + "'>" +
                                                "<span class='view icon fa fa-download' style='font-size:24px;cursor:pointer;text-align:center;width:80%;color:#000;'>" +
                                                "</span></a></td>" +
                                                "<td class='even_row'>" +
                                                "<a><span class='view icon fa fa-trash delete' id='file_" + res.file_id + "' style='font-size:24px;cursor:pointer;text-align:center;width:80%;color:#000;'>" +
                                                "</span></a></td>" +
                                                "</tr>";
                                            $(".documents thead").replaceWith(tableHead);
                                            $(tableRow).prependTo(".documents tbody");
                                            $('.form').trigger("reset");
                                            $('.errorMessage').remove();
                                            $('.doc_list').slideDown();
                                            $('.doc_new').slideUp();
                                            $('.form-control').show();
                                            $('.control-label').show();
                                            // disable select after success upload
                                            $("[name='person_document-file']").prop("disabled", true);
                                            $("[name='person_document-file']").prev("label").html('Select file<sup>*</sup>');
                                        } else {
                                            $("#" + $this.attr('id') + "InfoMessage").fadeToggle('slow');
                                        }

                                        if (typeof candidateUpload !== 'undefined') {
                                            // Give the user 3s to read the message
                                            window.setTimeout(function() {
                                                location.reload();
                                            }, 3000);
                                        }
                                    });
                                });
                            }
                        };

                        if (xhr.upload) {
                            xhr.upload.onloadstart = function () {
                                bar.percent = 0;
                                bar.draw();
                            };
                            xhr.upload.onprogress = function (evt) {
                                if (evt.lengthComputable) {
                                    bar.percent = evt.loaded / evt.total;
                                    bar.draw();
                                }
                            };
                            xhr.upload.onloadend = function () {
                                bar.percent = 1;
                                bar.draw();
                            };
                        }

                        xhr.send(data);
                    }
                }
            }
        });

    $('[data-adapt-mandatory-group="cv_upload_question"]').on('change', function () {
        if ($(this).val() == 'No') {// no cv remove validation
            $('.cv_upload_area').removeClass('has-error').children(":first").removeClass('has-error');
        }
    });
});

const getUrlParameter = function getUrlParameter(param) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(param);
};